<div
  class="sectionContainer containerMargins"
  [hidden]="!showThis"
  style="padding: 8px; border: 3px dashed var(--colorWarning)"
>
  <div style="display: flex">
    <div
      [class]="'iconButton'"
      style="margin-right: 8px; background-color: var(--colorWarning)"
      title="View master account"
      aria-label="View master account"
    >
      <app-icon [type]="'Statement'" [color]="'#ffffff'" />
    </div>
    <div style="flex: 1">
      <p>
        A new merchant statement will be arriving soon! Check the Statements tab
        below for updates.
      </p>
    </div>
  </div>
</div>
